// PaymentHistory.js

import React, { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import PaymentHistoryPDF from "./PaymentHistoryPDF";
import "./PaymentHistory.css";

import {
  FaTimes,
  FaDownload,
} from "react-icons/fa";

const PaymentHistory = ({
  open,
  onClose,
  shipment,
}) => {
  const [loading, setLoading] = useState(false);

  if (!open || !shipment) return null;

  const downloadPDF = async () => {
    try {
      setLoading(true);

      const blob = await pdf(
        <PaymentHistoryPDF
          shipment={shipment}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `Payment-History-${
        shipment.tracking_code || shipment.id
      }.pdf`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ph-overlay">
      <div className="ph-modal">

        {/* CLOSE */}
        <button
          className="ph-close"
          onClick={onClose}
        >
          <FaTimes />
        </button>

        {/* HEADER */}
        <h2 className="ph-title">
          Payment History
        </h2>

        <p className="ph-sub">
          {shipment.customer_name} •{" "}
          {shipment.tracking_code}
        </p>

        {/* IMAGE */}
        {shipment.goods_image && (
          <img
            src={shipment.goods_image}
            className="ph-image"
            alt=""
          />
        )}

        {/* SUMMARY */}
        <div className="ph-summary">
          <p>
            Total Paid:{" "}
            <b>${shipment.amount_paid}</b>
          </p>

          <p>
            Balance:{" "}
            <b>${shipment.balance}</b>
          </p>
        </div>

        {/* DOWNLOAD BTN */}
        <button
          className="ph-download"
          onClick={downloadPDF}
        >
          <FaDownload />{" "}
          {loading
            ? "Generating..."
            : "Download History"}
        </button>

        {/* LIST */}
        <div className="ph-list">
          {shipment.payments?.map(
            (p, i) => (
              <div
                className="ph-item"
                key={i}
              >
                <span>
                  {new Date(
                    p.created_at
                  ).toLocaleString()}
                </span>

                <span>
                  {p.payment_type === "us"
                    ? "USA"
                    : "Liberia"}
                </span>

                <span>${p.amount}</span>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;